import { selectUserIsSchoolStudent } from '~/auth/slices/auth.slice'
import { useAppSelector } from '~/redux/hooks'

/**
 * School pupils must not change their own password: hom-api keeps their plaintext credential in the
 * teacher reveal vault and only re-encrypts it at login, so a self-service change would leave the
 * teacher's reveal showing a stale password.
 *
 * Role-based on purpose — `appConfig.isSchoolPlatform` is true for the whole school deploy and would
 * also strip the tab from teachers and school admins.
 */
export function useCanChangePassword(): boolean {
  return !useAppSelector(selectUserIsSchoolStudent)
}
